const mapEmbeds = document.querySelectorAll(".map-embed-container");

for (let embed of mapEmbeds) {
    const toggle = embed.querySelector(".map-embed-toggle");
    toggle?.addEventListener("click", (e) => {
        if (
            !embed.classList.contains("show-map") &&
            !document.body.classList.contains("map-embed-open")
        ) {
            e.stopPropagation();
            embed.classList.add("show-map");
            document.body.addEventListener("click", close);
            document.body.classList.add("map-embed-open");
        } else {
            close();
        }
    });

    function close() {
        embed.classList.remove("show-map");
        document.body.removeEventListener("click", close);
        document.body.classList.remove("map-embed-open");
    }
}
